var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.651 11.7384H14.2172C14.6576 11.7384 14.7205 12.3675 14.2801 12.4934L14.4059 14.5066L13.9656 15.7649L13.4622 14.5066L13.5881 12.4934C13.1477 12.3675 13.2106 11.7384 13.651 11.7384ZM13.9656 4C15.7271 4 17.1112 5.44702 17.1112 7.20861C17.1112 8.9702 15.7271 10.3543 13.9656 10.3543C12.204 10.3543 10.7569 8.9702 10.7569 7.20861C10.7569 5.44702 12.204 4 13.9656 4ZM11.7636 11.9272L13.9656 17.4636L16.1046 11.9272C18.3066 11.9272 20.0682 13.3113 20.0682 15.5762V21.7417C20.0682 22.4338 19.502 23 18.8728 23H9.05827C8.36621 23 7.79999 22.4338 7.79999 21.7417V15.5762C7.79999 13.3113 9.56158 11.9272 11.7636 11.9272Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcManager);
export default __webpack_public_path__ + "static/media/ic-manager.9a252f5c.svg";
export { ForwardRef as ReactComponent };